import React from 'react';
import {
  NewTable,
  Dropdown,
  useSelectable,
  NewCheckbox,
  useSort,
  Currency,
  Status,
  FormattedNumber,
  NewInput,
  Button,
} from '@carta/ink';

const data = [
  {
    id: 12429,
    issue_date: new Date('01/01/2021'),
    label: 'PC-23',
    name: 'Amanda Domingues',
    price_per_share: '2.75',
    quantity: '20',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/12429/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/12429/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/12429/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/47567/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '550000.00',
  },
  {
    id: 50,
    issue_date: new Date('05/01/2014'),
    label: 'CS-11',
    name: 'Emilyo Wilson',
    price_per_share: '0.17',
    quantity: '10000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'certificate' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/50/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/50/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/50/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5314/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '1700.00',
  },
  {
    id: 51,
    issue_date: new Date('09/12/2014'),
    label: 'CS-12',
    name: 'Emilyo Wilson',
    price_per_share: '0.17',
    quantity: '25000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'certificate' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/51/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/51/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/51/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5314/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '4250.00',
  },
  {
    id: 29,
    issue_date: new Date('01/31/2013'),
    label: 'CS-1',
    name: 'Emily Wilson',
    price_per_share: '0.10',
    quantity: '2500000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: true,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/29/',
        open_in_page: true,
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/29/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Transferred',
    status_links: [
      { id: 2956, pk_key: 'certificate_pk', prefix_label: 'CS-25' },
      { id: 2957, pk_key: 'certificate_pk', prefix_label: 'CS-26' },
    ],
    transaction_value: '250000.00',
  },
  {
    id: 45,
    issue_date: new Date('12/01/2012'),
    label: 'CS-6',
    name: 'Emily Wilson',
    price_per_share: '0.10',
    quantity: '1500000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/45/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '150000.00',
  },
  {
    id: 46,
    issue_date: new Date('01/02/2014'),
    label: 'CS-7',
    name: 'Emily Wilson',
    price_per_share: '0.17',
    quantity: '40000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/46/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/46/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/46/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '6800.00',
  },
  {
    id: 47,
    issue_date: new Date('01/02/2013'),
    label: 'CS-8',
    name: 'Emily Wilson',
    price_per_share: '0.11',
    quantity: '40000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: true,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/47/',
        open_in_page: true,
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/47/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Repurchased',
    status_links: [{ id: 48, pk_key: 'certificate_pk', prefix_label: 'CS-9' }],
    transaction_value: '4400.00',
  },
  {
    id: 48,
    issue_date: new Date('04/01/2014'),
    label: 'CS-9',
    name: 'Emily Wilson',
    price_per_share: '0.11',
    quantity: '28000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/48/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/48/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/48/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '3080.00',
  },
  {
    id: 49,
    issue_date: new Date('01/18/2021'),
    label: 'CS-10',
    name: 'Emily Wilson',
    price_per_share: '0.20',
    quantity: '50000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/49/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/49/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/49/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '10000.00',
  },
  {
    id: 2776,
    issue_date: new Date('05/25/2017'),
    label: 'CS-17',
    name: 'Emily Wilson',
    price_per_share: null,
    quantity: '10000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/2776/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/2776/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/2776/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '0.00',
  },
  {
    id: 2950,
    issue_date: new Date('10/26/2017'),
    label: 'CS-23',
    name: 'Emily Wilson',
    price_per_share: '0.17',
    quantity: '1200',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2950/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '204.00',
  },
  {
    id: 2956,
    issue_date: new Date('10/26/2017'),
    label: 'CS-25',
    name: 'Emily Wilson',
    price_per_share: '0.10',
    quantity: '250000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/2956/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '587500.00',
  },
  {
    id: 2957,
    issue_date: new Date('10/26/2017'),
    label: 'CS-26',
    name: 'Emily Wilson',
    price_per_share: null,
    quantity: '2250000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/2957/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/2957/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/2957/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4902/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '225000.00',
  },
  {
    id: 650,
    issue_date: new Date('11/15/2013'),
    label: 'PA-4',
    name: 'Goddard Capital Fund I, LP',
    price_per_share: '0.44',
    quantity: '150000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/650/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/650/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/650/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4910/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '66750.00',
  },
  {
    id: 661,
    issue_date: new Date('09/09/2014'),
    label: 'PB-4',
    name: 'Goddard Capital Fund I, LP',
    price_per_share: '1.22',
    quantity: '150000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/661/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/661/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/661/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4910/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '183000.00',
  },
  {
    id: 832,
    issue_date: new Date('08/08/2016'),
    label: 'CS-13',
    name: 'Jack Greene',
    price_per_share: '0.64',
    quantity: '1228',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/832/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/832/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/832/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5016/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '785.92',
  },
  {
    id: 833,
    issue_date: new Date('08/01/2016'),
    label: 'CS-14',
    name: 'Jackie Frank',
    price_per_share: '0.64',
    quantity: '2628',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/833/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/833/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/833/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5034/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '1681.92',
  },
  {
    id: 652,
    issue_date: new Date('11/15/2013'),
    label: 'PA-6',
    name: 'Jake Pappas',
    price_per_share: '0.44',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/652/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/652/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/652/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4908/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '80100.00',
  },
  {
    id: 663,
    issue_date: new Date('09/11/2014'),
    label: 'PB-6',
    name: 'Jake Pappas',
    price_per_share: '1.22',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/663/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/663/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/663/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4908/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '219600.00',
  },
  {
    id: 39,
    issue_date: new Date('04/10/2013'),
    label: 'PS-7',
    name: 'Jake Pappas',
    price_per_share: '0.26',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/39/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/39/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/39/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4908/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '47700.00',
  },
  {
    id: 30,
    issue_date: new Date('01/31/2013'),
    label: 'CS-2',
    name: 'James Gillis',
    price_per_share: '0.10',
    quantity: '2500000',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/30/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/30/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/30/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4912/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '250000.00',
  },
  {
    id: 649,
    issue_date: new Date('11/15/2013'),
    label: 'PA-3',
    name: 'Jane Porter',
    price_per_share: '0.44',
    quantity: '150000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: true,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/649/',
        open_in_page: true,
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/649/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5309/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '66750.00',
  },
  {
    id: 660,
    issue_date: new Date('09/08/2014'),
    label: 'PB-3',
    name: 'Jane Porter',
    price_per_share: '1.22',
    quantity: '220000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/660/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/660/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/660/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5309/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '268400.00',
  },
  {
    id: 666,
    issue_date: new Date('09/14/2014'),
    label: 'PB-9',
    name: 'Janet Sugiyama',
    price_per_share: '1.22',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/666/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/666/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/666/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4905/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '219600.00',
  },
  {
    id: 42,
    issue_date: new Date('04/10/2013'),
    label: 'PS-10',
    name: 'Janet Sugiyama',
    price_per_share: '0.26',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/42/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4905/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '47700.00',
  },
  {
    id: 654,
    issue_date: new Date('11/15/2013'),
    label: 'PA-8',
    name: 'Jared Firestone',
    price_per_share: '0.44',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/654/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/654/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/654/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5310/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '80100.00',
  },
  {
    id: 665,
    issue_date: new Date('09/13/2014'),
    label: 'PB-8',
    name: 'Jared Firestone',
    price_per_share: '1.22',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/665/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/665/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/665/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5310/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '219600.00',
  },
  {
    id: 653,
    issue_date: new Date('11/15/2013'),
    label: 'PA-7',
    name: 'Jennie Craw',
    price_per_share: '0.44',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/653/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/653/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/653/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4907/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '80100.00',
  },
  {
    id: 664,
    issue_date: new Date('09/12/2014'),
    label: 'PB-7',
    name: 'Jennie Craw',
    price_per_share: '1.22',
    quantity: '100000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/664/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/664/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/664/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4907/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '122000.00',
  },
  {
    id: 40,
    issue_date: new Date('04/10/2013'),
    label: 'PS-8',
    name: 'Jennie Craw',
    price_per_share: '0.26',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/40/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/40/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/40/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4907/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '47700.00',
  },
  {
    id: 43,
    issue_date: new Date('12/01/2013'),
    label: 'CS-5',
    name: 'Jeremy D. Mac',
    price_per_share: '0.20',
    quantity: '15000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/43/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/43/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/43/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5306/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '3000.00',
  },
  {
    id: 5281,
    issue_date: new Date('05/01/2018'),
    label: 'CS-27',
    name: 'Joao das Neves',
    price_per_share: '0.33',
    quantity: '1032',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Modify vesting schedule', header: 'RSA' },
      { action: 'accelerateVestingSchedule', label: 'Accelerate vesting', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/5281/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/5281/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/5281/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/11226/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '80000.00',
  },
  {
    id: 12328,
    issue_date: new Date('08/18/2020'),
    label: 'CS-30',
    name: 'Joao das Neves',
    price_per_share: '0.00',
    quantity: '2500',
    security_actions: [
      { action: 'modifySecurity', label: 'Modify RSA', disabled: false, disabled_text: '', header: 'RSA' },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'RSA' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/12328/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/12328/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel RSA', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only RSAs that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print RSA', type: 'url', url: '/certificates/12328/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete RSAs that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete RSA',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/11226/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '0.00',
  },
  {
    id: 12327,
    issue_date: new Date('07/22/2020'),
    label: 'PC-22',
    name: 'Joao das Neves',
    price_per_share: '2.75',
    quantity: '1500',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/12327/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/12327/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/12327/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/11226/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '100.00',
  },
  {
    id: 1192,
    issue_date: new Date('08/25/2016'),
    label: 'PC-3',
    name: 'Krakatoa Ventures',
    price_per_share: '2.75',
    quantity: '200000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/1192/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/1192/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/1192/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/6114/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '550000.00',
  },
  {
    id: 888,
    issue_date: new Date('11/15/2013'),
    label: 'PA-1',
    name: 'Krakatoa Ventures Fund I, L.P.',
    price_per_share: '0.44',
    quantity: '2247191',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: true,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/888/',
        open_in_page: true,
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/888/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5375/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Transferred',
    status_links: [
      { id: 2952, pk_key: 'certificate_pk', prefix_label: 'PA-12' },
      { id: 2953, pk_key: 'certificate_pk', prefix_label: 'PA-13' },
    ],
    transaction_value: '1000000.00',
  },
  {
    id: 2952,
    issue_date: new Date('10/26/2017'),
    label: 'PA-12',
    name: 'Krakatoa Ventures Fund I, L.P.',
    price_per_share: '0.44',
    quantity: '30000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2952/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5375/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '70500.00',
  },
  {
    id: 2953,
    issue_date: new Date('10/26/2017'),
    label: 'PA-13',
    name: 'Krakatoa Ventures Fund I, L.P.',
    price_per_share: '0.44',
    quantity: '2217191',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/2953/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/2953/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2953/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5375/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '986650.00',
  },
  {
    id: 889,
    issue_date: new Date('09/06/2014'),
    label: 'PB-1',
    name: 'Krakatoa Ventures Fund I, L.P.',
    price_per_share: '1.22',
    quantity: '1639344',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/889/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/889/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/889/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5375/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '1999999.68',
  },
  {
    id: 886,
    issue_date: new Date('04/10/2013'),
    label: 'PS-4',
    name: 'Krakatoa Ventures Fund I, L.P.',
    price_per_share: '0.26',
    quantity: '150000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/886/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/886/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/886/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5375/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '39750.00',
  },
  {
    id: 887,
    issue_date: new Date('04/10/2013'),
    label: 'PS-9',
    name: 'Krakatoa Ventures Fund I, L.P.',
    price_per_share: '0.26',
    quantity: '416038',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/887/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/887/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/887/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5375/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '110250.07',
  },
  {
    id: 7901,
    issue_date: new Date('01/25/2016'),
    label: 'PS-11',
    name: 'Krakatoa Ventures Fund VII, L.P.',
    price_per_share: '0.26',
    quantity: '1000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/7901/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/7901/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/7901/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/15103/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '2750.00',
  },
  {
    id: 2778,
    issue_date: new Date('11/15/2013'),
    label: 'PA-9',
    name: 'Laplante Ventures II, LP',
    price_per_share: '0.44',
    quantity: '180000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: true,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/2778/',
        open_in_page: true,
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2778/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/8117/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Transferred',
    status_links: [
      { id: 2954, pk_key: 'certificate_pk', prefix_label: 'PA-14' },
      { id: 2955, pk_key: 'certificate_pk', prefix_label: 'PA-15' },
    ],
    transaction_value: '80100.00',
  },
  {
    id: 2954,
    issue_date: new Date('10/26/2017'),
    label: 'PA-14',
    name: 'Laplante Ventures II, LP',
    price_per_share: '0.44',
    quantity: '36000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2954/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/8117/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '84600.00',
  },
  {
    id: 2955,
    issue_date: new Date('10/26/2017'),
    label: 'PA-15',
    name: 'Laplante Ventures II, LP',
    price_per_share: '0.44',
    quantity: '144000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/2955/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/2955/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2955/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/8117/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '64080.00',
  },
  {
    id: 7900,
    issue_date: new Date('12/01/2018'),
    label: 'PD-1',
    name: 'Laplante Ventures II, LP',
    price_per_share: '5.36',
    quantity: '1000000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/7900/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/7900/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { action: 'resendIssuable', label: 'Resend to shareholder', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/7900/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/8117/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '5360000.00',
  },
  {
    id: 657,
    issue_date: new Date('11/15/2013'),
    label: 'PA-11',
    name: 'Lapoint Ventures',
    price_per_share: '0.44',
    quantity: '50000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'repurchaseIssuable',
        label: 'Repurchase shares',
        header: 'transactions',
        type: 'url',
        url: '/certificates/repurchases/7/from/657/',
        open_in_page: true,
      },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/657/',
        open_in_page: true,
      },
      { action: 'cancelIssuable', label: 'Cancel certificate', header: 'transactions' },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/657/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4962/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Outstanding',
    status_links: [],
    transaction_value: '22250.00',
  },
  {
    id: 2951,
    issue_date: new Date('10/26/2017'),
    label: 'CS-24',
    name: 'Mary Stuart',
    price_per_share: '0.17',
    quantity: '2400',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2951/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/4923/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '408.00',
  },
  {
    id: 890,
    issue_date: new Date('01/25/2016'),
    label: 'PC-19',
    name: 'MD Technology Partners, L.P.',
    price_per_share: '2.75',
    quantity: '2005206',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        type: 'url',
        header: 'transactions',
        disabled: true,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
        url: '/certificates/transfers/7/from/890/',
        open_in_page: true,
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: true,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/890/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: true,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5376/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Transferred',
    status_links: [
      { id: 2958, pk_key: 'certificate_pk', prefix_label: 'PC-20' },
      { id: 2959, pk_key: 'certificate_pk', prefix_label: 'PC-21' },
    ],
    transaction_value: '5514316.50',
  },
  {
    id: 2958,
    issue_date: new Date('10/26/2017'),
    label: 'PC-20',
    name: 'MD Technology Partners, L.P.',
    price_per_share: '2.75',
    quantity: '400000',
    security_actions: [
      {
        action: 'modifySecurity',
        label: 'Modify certificate',
        disabled: false,
        disabled_text: '',
        header: 'certificate',
      },
      { action: 'modifyVestingSchedule', label: 'Add vesting schedule', header: 'certificate' },
      {
        action: 'newTransferIssuable',
        label: 'Transfer shares',
        header: 'transactions',
        disabled: false,
        disabled_text: 'Cannot transfer paper shares or shares that have already been transferred or repurchased',
      },
      {
        action: 'reverseCancel',
        label: 'Reverse cancellation',
        disabled: false,
        disabled_text: 'Can reverse cancel only certificates that have been canceled, repurchased.',
        header: 'transactions',
      },
      { action: 'privateNote', label: 'Add admin notes', header: 'other' },
      { label: 'Print certificate', type: 'url', url: '/certificates/2958/print/', header: 'other' },
      {
        action: 'staffDeleteIssuable',
        disabled: false,
        disabled_text:
          'Cannot delete certificates that have been accepted, transferred, repurchased, converted, issued from fully exercised grant or come from a convertible note or a transfer.',
        is_staff: true,
        label: 'Delete certificate',
        header: 'other',
      },
      {
        label: 'Terminate stakeholder',
        type: 'url',
        url: '/corporations/7/stakeholders/5376/terminate/',
        header: 'stakeholder',
      },
    ],
    status_explanation: 'Canceled',
    status_links: [],
    transaction_value: '940000.00',
  },
];

const dataSorted = [...data];

export default function NewTableBenchmarkExpose() {
  const [selected, selectedActions] = useSelectable(dataSorted);
  const [sorted, sortedActions] = useSort(dataSorted);
  const [values, setValues] = React.useState({});

  const defineStatusColor = status => {
    if (status === 'Outstanding') {
      return 'green';
    }
    return 'red';
  };

  const defineStatusLabel = d => {
    if (d.status_links.length) {
      `${d.status_explanation} - ${d.status_links.map(sl => sl.prefix_label).join(', ')}`;
    }
    return d.status_explanation;
  };

  const handleChange = e => {
    e.persist();
    setValues(prevValues => {
      return {
        ...prevValues,
        [e.target.id]: e.target.value,
      };
    });
  };

  return (
    <NewTable id="newtable-benchmark-test">
      <NewTable.Head>
        <NewTable.Row>
          <NewTable.HeadCell preset="checkbox">
            <NewCheckbox id="select-all" checked={selected.allRows} onChange={selectedActions.toggleAllRows} />
          </NewTable.HeadCell>
          <NewTable.HeadCell preset="twiddleIcon">
            <NewTable.Twiddle.ExpandAll totalLevels={1} />
          </NewTable.HeadCell>
          <NewTable.HeadCell>
            <NewTable.Pin {...sortedActions.getPinProps('label')}>Security</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell>
            <NewTable.Pin {...sortedActions.getPinProps('name')}>Stakeholder</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell>
            <NewTable.Pin {...sortedActions.getPinProps('status_explanation')}>Status</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell align="right">
            <NewTable.Pin {...sortedActions.getPinProps('quantity')}>Shares</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell align="right">
            <NewTable.Pin {...sortedActions.getPinProps('price_per_share')}>Price/Share</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell align="right">
            <NewTable.Pin {...sortedActions.getPinProps('transaction_value')}>Transaction Value</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell align="right">
            <NewTable.Pin {...sortedActions.getPinProps('issue_date')}>Issue Date</NewTable.Pin>
          </NewTable.HeadCell>
          <NewTable.HeadCell preset="action" />
        </NewTable.Row>
      </NewTable.Head>
      <NewTable.Body>
        {sorted.items.map(d => (
          <NewTable.Twiddle key={d.id}>
            {({ open, setOpen }) => (
              <>
                <NewTable.Row onClick={() => setOpen(!open)} selected={selected.rows[d.id]}>
                  <NewTable.Cell preset="checkbox">
                    <NewCheckbox id={String(d.id)} onChange={selectedActions.toggleRow} checked={selected.rows[d.id]} />
                  </NewTable.Cell>
                  <NewTable.Cell preset="twiddleIcon">
                    <NewTable.Twiddle.Icon />
                  </NewTable.Cell>
                  <NewTable.Cell>{d.label}</NewTable.Cell>
                  <NewTable.Cell>{d.name}</NewTable.Cell>
                  <NewTable.Cell>
                    <Status isMini color={defineStatusColor(d.status_explanation)} label={defineStatusLabel(d)} />
                  </NewTable.Cell>
                  <NewTable.Cell align="right">
                    <FormattedNumber value={d.quantity} />
                  </NewTable.Cell>
                  <NewTable.Cell align="right">
                    <Currency value={d.price_per_share ?? 0} />
                  </NewTable.Cell>
                  <NewTable.Cell align="right">
                    <Currency value={d.transaction_value} />
                  </NewTable.Cell>
                  <NewTable.Cell align="right">{d.issue_date.toLocaleDateString()}</NewTable.Cell>
                  <NewTable.Cell preset="action">
                    <Dropdown
                      align="right"
                      scrollable
                      trigger={({ onClick }) => <Dropdown.Trigger onClick={onClick} type="actions" />}
                    >
                      {d.security_actions.map((action, i) => (
                        <Dropdown.Item
                          key={i}
                          disabled={action.disabled}
                          render={() => {
                            if (action.disabled) {
                              return (
                                <Dropdown.Tooltip
                                  placement="left"
                                  render={() => <Dropdown.Button>{action.label}</Dropdown.Button>}
                                >
                                  {action.disabled_text}
                                </Dropdown.Tooltip>
                              );
                            }
                            return <Dropdown.Button>{action.label}</Dropdown.Button>;
                          }}
                        />
                      ))}
                    </Dropdown>
                  </NewTable.Cell>
                </NewTable.Row>
                {open && (
                  <NewTable.Row>
                    <NewTable.Cell colSpan={10}>
                      <NewTable>
                        <NewTable.Head>
                          <NewTable.Row>
                            <NewTable.HeadCell>Security</NewTable.HeadCell>
                            <NewTable.HeadCell>Stakeholder</NewTable.HeadCell>
                            <NewTable.HeadCell>Shares</NewTable.HeadCell>
                            <NewTable.HeadCell colSpan={2}>Price/Share</NewTable.HeadCell>
                          </NewTable.Row>
                        </NewTable.Head>
                        <NewTable.Body>
                          <NewTable.Row>
                            <NewTable.Cell preset="editable">
                              <NewInput id={`label-${d.id}`} value={values[`label-${d.id}`]} onChange={handleChange} />
                            </NewTable.Cell>
                            <NewTable.Cell preset="editable">
                              <NewInput id={`name-${d.id}`} value={values[`name-${d.id}`]} onChange={handleChange} />
                            </NewTable.Cell>
                            <NewTable.Cell preset="editable">
                              <NewInput
                                id={`quantity-${d.id}`}
                                value={values[`quantity-${d.id}`]}
                                onChange={handleChange}
                              />
                            </NewTable.Cell>
                            <NewTable.Cell preset="editable">
                              <NewInput
                                id={`price_per_share-${d.id}`}
                                value={values[`price_per_share-${d.id}`]}
                                onChange={handleChange}
                              />
                            </NewTable.Cell>
                            <NewTable.Cell align="right">
                              <Button isCell type="primary">
                                Save
                              </Button>
                            </NewTable.Cell>
                          </NewTable.Row>
                        </NewTable.Body>
                      </NewTable>
                    </NewTable.Cell>
                  </NewTable.Row>
                )}
              </>
            )}
          </NewTable.Twiddle>
        ))}
      </NewTable.Body>
    </NewTable>
  );
}
